import React from 'react';
import SecuritySection from './ui/SecuritySection';
import SecurityStatusPill from './ui/SecurityStatusPill';
import { IconCheck, IconShield } from '../../ui/adminIcons';
import { PROTECTION_FEATURES } from '../securityConstants';

function ProtectionCard({ title, active, blockedLabel, blockedValue, features }) {
  return (
    <div className="vx-sec-panel">
      <div className="vx-sec-panel-header">
        <h3 className="vx-sec-panel-title">{title}</h3>
        <SecurityStatusPill active={active} />
      </div>
      <div className="vx-sec-kv">
        <span className="vx-sec-kv-label">{blockedLabel}</span>
        <span className="vx-sec-kv-value">{blockedValue}</span>
      </div>
      <ul className="vx-sec-feature-list">
        {features.map((feature) => (
          <li key={feature} className="vx-sec-feature-item">
            <span className="vx-sec-feature-icon" aria-hidden="true"><IconCheck title="" /></span>
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function SecurityProtectionPanel({ protectionStats }) {
  return (
    <SecuritySection title="Protection status" icon={<IconShield />}>
      <div className="vx-sec-grid vx-sec-grid--panels">
        <ProtectionCard
          title="File protection"
          active={protectionStats.fileProtection.active}
          blockedLabel="Blocked attempts"
          blockedValue={protectionStats.fileProtection.blocked}
          features={PROTECTION_FEATURES.file}
        />
        <ProtectionCard
          title="Bot protection"
          active={protectionStats.botProtection.active}
          blockedLabel="Bots blocked"
          blockedValue={protectionStats.botProtection.blocked}
          features={PROTECTION_FEATURES.bot}
        />
        <ProtectionCard
          title="Threat intelligence"
          active={protectionStats.riskScoring.active}
          blockedLabel="High-risk IPs"
          blockedValue={protectionStats.riskScoring.highRiskIPs}
          features={PROTECTION_FEATURES.threat}
        />
      </div>
    </SecuritySection>
  );
}
